import type { GlobeFrame, HotZone, HotZoneCategory } from "@/types/gdelt";

export type GdeltExportActor = {
  code: string;
  name: string;
  countryCode: string;
  knownGroupCode: string;
  ethnicCode: string;
  religionCode1: string;
  religionCode2: string;
  typeCode1: string;
  typeCode2: string;
  typeCode3: string;
};

export type GdeltExportGeography = {
  type: number;
  name: string;
  countryCode: string;
  administrativeCode: string;
  latitude: number | null;
  longitude: number | null;
  featureId: string;
};

export type GdeltExportEvent = {
  globalEventId: string;
  eventDate: string;
  eventCode: string;
  eventBaseCode: string;
  eventRootCode: string;
  isRootEvent: boolean;
  quadClass: number;
  category: HotZoneCategory;
  goldsteinScale: number;
  averageTone: number;
  mentionCount: number;
  sourceCount: number;
  articleCount: number;
  actor1: GdeltExportActor;
  actor2: GdeltExportActor;
  actor1Geography: GdeltExportGeography;
  actor2Geography: GdeltExportGeography;
  location: GdeltExportGeography & { latitude: number; longitude: number };
  addedAt: string;
  sourceUrl: string;
};

export type GdeltExportHotZone = HotZone & {
  sourceEvent: GdeltExportEvent;
  significantWord: string;
};

export type GdeltExportFrameQuery = {
  windowMinutes: 15 | 60 | 360 | 1440;
  maximumZones?: number;
};

export type GdeltExportFrame = Omit<GlobeFrame, "zones"> & {
  zones: GdeltExportHotZone[];
  source: {
    dataset: "GDELT Export";
    fileName: string;
    temporalResolution: "daily-date";
    parsedEvents: number;
    locatedEvents: number;
  };
};

export function isGdeltExportHotZone(zone: HotZone): zone is GdeltExportHotZone {
  return "sourceEvent" in zone && "significantWord" in zone;
}
